/** When an active semester exists — longer than dashboard overview poll (90s). */
export const ACTIVE_SEMESTER_CACHE_MS = 120_000;

/** No active semester (404) — avoid repeated setup-phase noise; still recheck periodically. */
export const ACTIVE_SEMESTER_CACHE_MS_NONE = 5 * 60_000;

/**
 * Public class catalog (`GET /public/classes`) — short per-tab in-memory TTL so Explore
 * can reuse a successful fetch while navigating. Seat counts may lag briefly; the enroll
 * API still enforces capacity. Failures are not cached.
 */
export const PUBLIC_CLASSES_CACHE_MS = 30_000;

/** BroadcastChannel — other tabs refetch when a semester is activated. */
export const ACTIVE_SEMESTER_BROADCAST_CHANNEL = 'bhg-active-semester';

export const ACTIVE_SEMESTER_CHANGED_EVENT = 'bhg-active-semester-changed';
